export const findHezb = (number) => {
  let joz = [
    { min: "001001", max: "002043" },
    { min: "002044", max: "002074" },
    { min: "002075", max: "002105" },
    { min: "002106", max: "002141" },
    { min: "002142", max: "002176" },
    { min: "002177", max: "002202" },
    { min: "002203", max: "002232" },
    { min: "002233", max: "002252" },
    { min: "002253", max: "002271" },
    { min: "002272", max: "003014" },
    { min: "003015", max: "003051" },
    { min: "003052", max: "003092" },
    { min: "003093", max: "003132" },
    { min: "003133", max: "003170" },
    { min: "003171", max: "003200" },
    { min: "004001", max: "004023" },
    { min: "004024", max: "004057" },
    { min: "004058", max: "004087" },
    { min: "004088", max: "004113" },
    { min: "004114", max: "004147" },
    { min: "004148", max: "004176" },
    { min: "005001", max: "005026" },
    { min: "005027", max: "005050" },
    { min: "005051", max: "005081" },
    { min: "005082", max: "005108" },
    { min: "005109", max: "006035" },
    { min: "006036", max: "006073" },
    { min: "006074", max: "006110" },
    { min: "006111", max: "006140" },
    { min: "006141", max: "006165" },
    { min: "007001", max: "007046" },
    { min: "007047", max: "007087" },
    { min: "007088", max: "007141" },
    { min: "007142", max: "007170" },
    { min: "007171", max: "007206" },
    { min: "008001", max: "008040" },
    { min: "008041", max: "009075" },
    { min: "009001", max: "009033" },
    { min: "009034", max: "009059" },
    { min: "009060", max: "009092" },
    { min: "009093", max: "009121" },
    { min: "009122", max: "010025" },
    { min: "010026", max: "010070" },
    { min: "010071", max: "011005" },
    { min: "011006", max: "011040" },
    { min: "011041", max: "011083" },
    { min: "011084", max: "012006" },
    { min: "012007", max: "012052" },
    { min: "012053", max: "012100" },
    { min: "012101", max: "013018" },
    { min: "013019", max: "014009" },
    { min: "014010", max: "014052" },
    { min: "015001", max: "015099" },
    { min: "016001", max: "016050" },
    { min: "016051", max: "016089" },
    { min: "016090", max: "016128" },
    { min: "017001", max: "017049" },
    { min: "017050", max: "017098" },
    { min: "017099", max: "018031" },
    { min: "018032", max: "018074" },
    { min: "018075", max: "019021" },
    { min: "019022", max: "019098" },
    { min: "020001", max: "020082" },
    { min: "020083", max: "020135" },
    { min: "021001", max: "021050" },
    { min: "021051", max: "021112" },
    { min: "022001", max: "022037" },
    { min: "022038", max: "022078" },
    { min: "023001", max: "023074" },
    { min: "023074", max: "024020" },
    { min: "024021", max: "024052" },
    { min: "024053", max: "025020" },
    { min: "025021", max: "025077" },
    { min: "026001", max: "026110" },
    { min: "026111", max: "026227" },
    { min: "027001", max: "027055" },
    { min: "027056", max: "028011" },
    { min: "028012", max: "028050" },
    { min: "028051", max: "028088" },
    { min: "029001", max: "029045" },
    { min: "029046", max: "030030" },
    { min: "030031", max: "031021" },
    { min: "031022", max: "032030" },
    { min: "033001", max: "033030" },
    { min: "033031", max: "033059" },
    { min: "033060", max: "034023" },
    { min: "034024", max: "035014" },
    { min: "035015", max: "036027" },
    { min: "036028", max: "037021" },
    { min: "037022", max: "037144" },
    { min: "037145", max: "038051" },
    { min: "038052", max: "039031" },
    { min: "039032", max: "039075" },
    { min: "040001", max: "040040" },
    { min: "040041", max: "041008" },
    { min: "041009", max: "041046" },
    { min: "041047", max: "042026" },
    { min: "042027", max: "043023" },
    { min: "043024", max: "044016" },
    { min: "044017", max: "045037" },
    { min: "046001", max: "047009" },
    { min: "047010", max: "048017" },
    { min: "048018", max: "049013" },
    { min: "049014", max: "051030" },
    { min: "051031", max: "053025" },
    { min: "051031", max: "053025" },
    { min: "051026", max: "054055" },
    { min: "055001", max: "056074" },
    { min: "056075", max: "057029" },
    { min: "058001", max: "059010" },
    { min: "059011", max: "061014" },
    { min: "062001", max: "064018" },
    { min: "065001", max: "066012" },
    { min: "067001", max: "068052" },
    { min: "069001", max: "071028" },
    { min: "072001", max: "074056" },
    { min: "075001", max: "077050" },
    { min: "078001", max: "081029" },
    { min: "082001", max: "086017" },
    { min: "087001", max: "093011" },
    { min: "094001", max: "114006" },
  ];
  let result = 0;
  for (let item in joz) {
    let min = parseInt(joz[item].min);
    let max = parseInt(joz[item].max);
    let value = parseInt(number);
    if (value <= max && value >= min) {
      result = parseInt(item) + 1;
      break;
    }
  }
  return result;
};
export const findJoz = (number) => {
  const joz = [
    { min: "001001", max: "002141" },
    { min: "002142", max: "002252" },
    { min: "002253", max: "003091" },
    { min: "003092", max: "004023" },
    { min: "004024", max: "004147" },
    { min: "004148", max: "005081" },
    { min: "005082", max: "006111" },
    { min: "006112", max: "007088" },
    { min: "007089", max: "008040" },
    { min: "008041", max: "009092" },
    { min: "009093", max: "011005" },
    { min: "011006", max: "012053" },
    { min: "012054", max: "014052" },
    { min: "015001", max: "016128" },
    { min: "017001", max: "018074" },
    { min: "018075", max: "020135" },
    { min: "021001", max: "022078" },
    { min: "023001", max: "025020" },
    { min: "025021", max: "027055" },
    { min: "027056", max: "029045" },
    { min: "029046", max: "033030" },
    { min: "033031", max: "036027" },
    { min: "036028", max: "039031" },
    { min: "039032", max: "041046" },
    { min: "041047", max: "045037" },
    { min: "046001", max: "051030" },
    { min: "051031", max: "057029" },
    { min: "058001", max: "066012" },
    { min: "067001", max: "077050" },
    { min: "078001", max: "114006" },
  ];
  let result = 0;
  for (let item in joz) {
    let min = parseInt(joz[item].min);
    let max = parseInt(joz[item].max);
    let value = parseInt(number);
    if (value <= max && value >= min) {
      result = parseInt(item) + 1;
      break;
    }
  }
  return result;
};
